import Keyb from "keyb"
import Pointer from "poin"
import Screenfull from "screenfull"

import Game from "@frog/source/models/Game.js"
import Director from "@frog/source/juice/Director.js"
import Navigation from "@frog/source/models/Navigation.js"

import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"
import skills from "@frog/source/data/skills/skills.js"

import timings from "@frog/source/juice/utility/Timings.js"
import getTimeOfDay from "@frog/source/models/logic/getTimeOfDay.js"
const musics = {
    "/": {"eventpath": "event:/Music/Title_Screen_MX"},
    "/game": {"eventpath": "event:/Music/Title_Screen_MX"},
    "/game/encounters/first_day": {"eventpath": "event:/Music/Farm_MX"},
    "/game/encounters/next_day": {"eventpath": "event:/Music/Farm_MX"},
    "/game/town": {"eventpath": "event:/Music/Town_MX"},
}

export default new class App {
    update(delta) {
        // if(Keyb.wasJustPressed("<escape>", delta.ms)) {
        //     if(Navigation.state.devscreen != undefined) {
        //         Navigation.state.devscreen = undefined
        //     } else if(this.game != undefined
        //     && this.game.encounter != undefined
        //     && this.game.encounter.selection != undefined
        //     && this.game.encounter.selection.selectedUnit != undefined) {
        //         // ...
        //     } else if(Navigation.state.screen == "EncounterScreen"
        //     || Navigation.state.screen == "OverworldScreen") {
        //         if(Navigation.state.minimenu == undefined) {
        //             Navigation.state.minimenu = {"section": "MainSection"}
        //         } else if(Navigation.state.minimenu != undefined) {
        //             if(Navigation.state.minimenu.section == "MainSection") {
        //                 Navigation.state.minimenu = undefined
        //             } else if(Navigation.state.minimenu.section == "OptionsSection") {
        //                 Navigation.state.minimenu.section = "MainSection"
        //             }
        //         }
        //     }
        // }

        if(Navigation.state.minimenu != undefined) {
            // We're paused!!
            return
        }

        if(__STAGE__ == "DEVELOPMENT") {
            window.frog = window.frog || {}
            window.frog.app = this
        }

        if(this.game != undefined
        && this.game.encounter != undefined) {
            if(this.game.encounter.stage != undefined) {
                if(Pointer.isIgnoringForFrame > 0 != true) {
                    if(Pointer.wasJustPressed("primary", true, delta.ms)
                    || Keyb.wasJustPressed("<space>", delta.ms)) {
                        if(this.game.encounter.sequence != undefined) {
                            Sequence.seek(this.game.encounter.sequence)
                        }
                    }
                }
                Director.updateSequence({
                    "sequence": this.game.encounter.sequence,
                    "delta": delta,
                })
            }
            if(this.game.encounter != undefined
            && this.game.encounter.selection != undefined
            && this.game.encounter.selection.hoveredSkillKey != undefined) {
                const skill = skills.get(this.game.encounter.selection.hoveredSkillKey)
                if(skill.demonstration != undefined) {
                    Director.updateSequence({
                        "sequence": skill.demonstration.sequence,
                        "delta": delta,
                    })
                }
            }
        }

        if(this.game != undefined) {
            Game.update(this.game, delta)
        }

        if(Keyb.wasJustPressed("F")
        && Keyb.isPressed("<shift>")) {
            Screenfull.toggle()
        }
    }
    load(app) {
        this.game = Game.load(app.game)
    }
    loadTest(test) {
        if(test.snapshot == undefined) {
            console.log("Not a snapshot test:", test.slug)
            return
        }
        this.load({
            "navigation": {"screen": "EncounterScreen"},
            "game": {
                "encounter": {
                    "type": "combat",
                    "stage": test.snapshot.alphastage,
                    "steps": test.steps,
                    // "protoactions": test.snapshot.protoactions,
                }
            }
        })
    }
    getActiveStage() {
        if(this.game != undefined
        && this.game.encounter != undefined
        && this.game.encounter.sequence != undefined
        && this.game.encounter.sequence.steps != undefined
        && this.game.encounter.sequence.steps[0] != undefined
        && this.game.encounter.sequence.steps[0].stage != undefined) {
            return this.game.encounter.sequence.steps[0].stage
        }
        if(this.game != undefined
        && this.game.encounter != undefined
        && this.game.encounter.sequence != undefined
        && this.game.encounter.sequence.steps != undefined
        && this.game.encounter.sequence.steps[0] != undefined
        && this.game.encounter.sequence.steps[0].omegastage != undefined) {
            return this.game.encounter.sequence.steps[0].omegastage
        }
        if(this.game != undefined
        && this.game.encounter != undefined) {
            return this.game.encounter.stage
        }
    }
}

// TODO: Merge with Sequence class in Director.js
class Sequence {
    static seek(sequence) {
        if(sequence.steps == undefined) {
            return
        }
        Sequence.skip(sequence)

        // // Skip to the next "important step"
        // // or until their are no steps left.
        // while(sequence.steps.length > 0) {
        //     if(sequence.steps[0].isImportant) {
        //         break
        //     }
        //     if(sequence.steps[0].animation != undefined
        //     && sequence.steps[0].animation.isImportant == true) {
        //         break
        //     }
        //     Sequence.skip(sequence)
        // }
    }
    static skip(sequence) {
        const step = sequence.steps.shift()
        if(step != undefined) {
            if(step.func instanceof Function) {
                step.func()
            }
            if(step?.animation?.keyframes != undefined) {
                step.animation.keyframes.forEach((keyframe) => {
                    if(keyframe.function != undefined) {
                        keyframe.function()
                    }
                    if(keyframe.func != undefined) {
                        keyframe.func()
                    }
                    // TODO: keyframe.do and keyframe.func
                })
            }
            // step.deltastages.forEach((deltastage) => {
            //     if(deltastage.function instanceof Function) {
            //         deltastage.function()
            //     }
            // })
        }

        if(sequence.isLooping == true) {
            sequence.steps.push(Step.instantiate(step))
        }
    }
}
